import { all } from 'rsvp';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { EMBER_ROUTE_NAMES } from '../../../constants/routes';

/** @module */
const CreatorSignupProfileController = Controller.extend({
  router: service(),
  session: service(),

  /** @type {Ember.Service} */
  imageCommandService: service('commands/image-commands'),

  /** @type {Ember.Service} */
  userCommandService : service('commands/user-commands'),

  /** @inheritDoc */
  actions: {
    /**
     * @returns {string}
     */
    getDefaultUserPhotoUrl() {
      const {
        'model.user.image.cloudVersion': cloudVersion,
        'model.user.image.cloudId': cloudId,
      } = this.getProperties([
        'model.user.image.cloudVersion',
        'model.user.image.cloudId',
      ]);

      if (cloudVersion && cloudId) {
        return this.get('imageCommandService').cloudinaryProfileUrl(cloudVersion, cloudId);
      }

      return '';
    },

    /**
     * @param {DS.Model} photo
     * @returns {string}
     */
    getPhotoUrl(photo) {
      const { cloudVersion, cloudId } = photo.getProperties(['cloudVersion', 'cloudId']);
      return this.get('imageCommandService').cloudinaryProfileUrl(cloudVersion, cloudId);
    },

    /**
     * @param {Object} param
     * @param {number} param.min_rate
     * @param {number} param.max_rate
     * @param {string} param.phone
     * @param {string} param.slug
     * @param {DS.Model[]} param.services
     * @param {object|undefined} param.photo
     * @param {{ place_id: string }|undefined} param.place
     */
    updateUser({ min_rate: minRate, max_rate: maxRate, phone, slug, services, photo, place }) {
      const {
        userCommandService,
        imageCommandService,
        'model.user': user,
        'model.profile': profile,
      } = this.getProperties([
        'userCommandService',
        'imageCommandService',
        'model.user',
        'model.profile',
      ]);

      const imageSave = imageCommandService.associateImage(photo, user);
      const updateSlug = userCommandService.updateSlug(user, slug);

      return all([imageSave, updateSlug]).then(() => {
        const userProps = { slug, phone,};
        const userRelationships = { services };

        if (place) {
          userRelationships.location = place;
        }

        const profileProps = {
          minRate: parseInt(minRate, 10),
          maxRate: parseInt(maxRate, 10),
        };

        const userSave = userCommandService.updateUser(user, userProps, userRelationships);
        const profileSave = userCommandService.updateUserProfile(user, profile, profileProps);

        return all([userSave, profileSave]);
      }).then(() => {
        return this.session.loadCurrentUser();
      }).then(() => {
        return this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__BACKGROUND);
      });
    },

    /**
     * @param {File} file
     * @returns {Promise<DS.Model>}
     */
    uploadPhoto(file) {
      return this.get('imageCommandService').createDraftImage(file);
    },
  },
});

export default CreatorSignupProfileController;
